import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';


export default function Faculty() {
  
  const navigate = useNavigate();
  // CHECKING IF USER IS VALID
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/")
  }


  const [facultycode, setFacultycode] = useState("");
  const [facultyname, setFacultyname] = useState("");
  const [remarks, setRemarks] = useState("");
  const [message, setMessage] = useState("");
  const status = "active";

  const [errors, setErrors] = useState({ fcode: '', fname: '' }); //20/3/2024 for validation
  const [isaddfaculty, setAddFaculty] = useState(false);//20/3/2024


  const { http } = Api();
 

  //role validation -20/3/2024
  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id = localStorage.getItem("id");
      try {
      const response = await http.get('/Admin/get-all-user-permissions', {params: { user_id: id }});    
  
      const permissions = response.data;     
      
      permissions.forEach(permission => {
       
        if (permission.name === "add-faculty") {          
            setAddFaculty(true);
          }
        });
      } catch (error) {      
        setAddFaculty(false);
        
      }
    };
    access();
  }, []);




  const cancelForm = () => {
    navigate("/admin/faculty");
  };

  const saveForm = (event) => {

    event.preventDefault();

    //form validation
    const updatedErrors = {};
    let hasError = false;

    if (!facultycode) {
      updatedErrors.fcode = 'Please enter a faculty code';
      hasError = true;     
    }
    if (!facultyname) {
      updatedErrors.fname = 'Please enter a faculty name';
      hasError = true;    

    }

    if (hasError) {
      setErrors(updatedErrors);
      if (!facultycode) {
          document.getElementById('facultycode').focus();
      } else if (!facultyname) {
          document.getElementById('facultyname').focus();
      }
  } else {
      setErrors({ fcode: '', fname: '' });

      const remarksValue = remarks ? remarks : "Null";
      http.post('/Admin/savefaculty', { faculty_name: facultyname, faculty_code: facultycode, remarks: remarksValue, status: status })
        .then(response => {
          console.log(response);
          if (response.data.status_code === "MSG1") {

            setMessage("New Faculty Added");
            sessionStorage.setItem("message", "New Faculty Added Successfully");
            navigate("/admin/faculty");

          }
        })
        .catch(error => {
          console.error(error);

          if (error.response && error.response.status === 500) {
            setMessage("Duplicate Value: This faculty already exists");
          } else {
            setMessage("Something Went Wrong");

          }
        });
    }
  };


  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">                
                <div className="col-md-12">
                  <div className="card-header"> 
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Add Faculty</h5>
                    </div>
                  </div>
                  <div className="card-body">
                  {message && (
                                                <div className="alert alert-danger mar2" role="alert">
                                                    <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                                                </div>
                                            )}
                    <div className="card-body pdg">
                      <div className="table-responsive">

                        {isaddfaculty && (
                        <form className="form theme-form">
                          <div className="card-body custom-input">
                          
                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Faculty Code <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                    <input className="form-control input-air-primary" type="text" id="facultycode" name="facultycode" onChange={(e) => setFacultycode(e.target.value)} placeholder="Faculty Code" maxLength={3}/>
                                    {errors.fcode && <p className="text-danger">{errors.fcode}</p>}  {/* //20-3-2024*/}
                                  </div>
                                 
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Faculty Name <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                    <input className="form-control input-air-primary" type="text" id="facultyname" name="facultyname" onChange={(e) => setFacultyname(e.target.value)} placeholder="Faculty Name" />
                                    {errors.fname && <p className="text-danger">{errors.fname}</p>} {/* //20-3-2024*/}
                                  </div>
                                  
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Remarks</label>
                                  <div className="col-sm-9">
                                    <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" onChange={(e) => setRemarks(e.target.value)} />
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          
                            <div className="col-md-12 txt-aln">
                              <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>
                          
                        </form>
)}


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
